package com.shadowings.gero.data.lessons.chapter16

import com.shadowings.gero.data.lessons.buildHieroQuizContent
import com.shadowings.gero.data.lessons.toHieroExplanation
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_segni_degli_aggettivi_1
import gero.composeapp.generated.resources.exp_content_segni_degli_aggettivi_2
import gero.composeapp.generated.resources.exp_content_segni_degli_aggettivi_3
import gero.composeapp.generated.resources.exp_content_segni_degli_aggettivi_4
import gero.composeapp.generated.resources.exp_content_segni_degli_aggettivi_5
import gero.composeapp.generated.resources.exp_content_segni_degli_aggettivi_6
import gero.composeapp.generated.resources.exp_content_segni_degli_aggettivi_7
import gero.composeapp.generated.resources.exp_title_segni_degli_aggettivi

// New signs needed to write the adjectives of SCORTA_DI_AGGETTIVI (bin, mꜣꜥ).
val segniDegliAggettiviHieroCodes = listOf("S3", "Aa11", "H2")

// Already-taught signs, used only to pad the quiz to 10 questions and as
// extra pronunciation distractors - not re-taught here.
private val segniDegliAggettiviReviewHieroCodes = listOf(
    "G37", "D60", "A24", "U2", "D36", "D58", "M17", "Y1",
    "N35", "F35", "O29A", "V30", "I10", "D21", "X1"
)

fun getSegniDegliAggettiviContent(
    hiero: List<Hiero>,
    languageCode: String
): List<IExplanation> {
    val intro = listOf(
        ExplanationContent(
            title = Res.string.exp_title_segni_degli_aggettivi,
            content = Res.string.exp_content_segni_degli_aggettivi_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_segni_degli_aggettivi,
            content = Res.string.exp_content_segni_degli_aggettivi_2,
            face = Faces.Sleeping,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_segni_degli_aggettivi,
            content = Res.string.exp_content_segni_degli_aggettivi_3,
            face = Faces.Sad,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_segni_degli_aggettivi,
            content = Res.string.exp_content_segni_degli_aggettivi_4,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_segni_degli_aggettivi,
            content = Res.string.exp_content_segni_degli_aggettivi_5,
            face = Faces.Sad,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_segni_degli_aggettivi,
            content = Res.string.exp_content_segni_degli_aggettivi_6,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_segni_degli_aggettivi,
            content = Res.string.exp_content_segni_degli_aggettivi_7,
            face = Faces.Perfect,
            character = Characters.Alyn,
        )
    )

    return intro + segniDegliAggettiviHieroCodes.toHieroExplanation(hiero, languageCode)
}

fun getSegniDegliAggettiviQuizContent(
    hiero: List<Hiero>,
    languageCode: String
): List<IQuizContent> {
    return buildHieroQuizContent(
        hiero = hiero,
        hieroContent = getSegniDegliAggettiviContent(hiero, languageCode),
        languageCode = languageCode,
        previousHieroContent = segniDegliAggettiviReviewHieroCodes.toHieroExplanation(hiero, languageCode)
    )
}
